// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Studios from "./components/Studios";
import Instructors from "./components/Instructors";
import Lessons from "./components/Lessons";
import Attendance from "./components/Attendance";
import Login from "./components/Login";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* 認証ガード + サイドバーレイアウト */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/lessons" element={<Lessons />} />
              <Route path="/studios" element={<Studios />} />
              <Route path="/instructors" element={<Instructors />} />
              <Route path="/attendance" element={<Attendance />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/lessons" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
